// Styles for ExploreDestinationSkeletonLoader go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledExploreDestinationSkeletonLoader = styled.div`
  .loader-container {
    height: ${toRem(408)};
  }
`;
